<template>
    <div id="app">
        <transition name="el-fade-in-linear">
            <router-view/>
        </transition>
    </div>
</template>
<script>

export default {
    data(){
        return{}
    },
    created(){
        this.$router.afterEach((to,from)=>{ // 监听路由变化判断对应逻辑
            history.pushState(null, null, document.URL);
            if(from.fullPath === '/'){
                if(to.name=="preview" || to.name=='Login'){
                    return
                }else if(to.path.indexOf('/single/')>-1){
                    return
                }else{
                    this.$router.push({path:'/'})
                }
            }
        })
    },
}
</script>
<style lang="less">

</style>
